import { render } from "./file-uploader.vue?vue&type=template&id=0aed79cb&scoped=true"
import script from "./file-uploader.vue?vue&type=script&lang=js"
export * from "./file-uploader.vue?vue&type=script&lang=js"

import "./file-uploader.vue?vue&type=style&index=0&id=0aed79cb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aed79cb"]])

export default __exports__